import Header from "./Header";

interface LayoutProps {
    children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div className="min-w-[1560px]">
            <Header />
            <div className="min-h-[calc(100vh-80px)] bg-[#f7f6fb] pl-[360px]">
                <div className="p-[36px_50px]">{children}</div>
            </div>
        </div>
    );
}
